module.exports = {"en":{"accept":"Accept","decline":"Decline"},"de":{"accept":"Annehmen","decline":"Ablehnen"},"fr":{"accept":"Accepter","decline":"Décliner"},"ru":{"accept":"Принять","decline":"Отклонить"},"zh":{"accept":"Accept","decline":"Decline"}}


//////////////////
// WEBPACK FOOTER
// ./src/features/Eula/localization/localization.json
// module id = 931
// module chunks = 0